import React, {Component} from 'react';
import {authService} from "../auth";
import axios from "axios";
import * as _ from "lodash";
import Box from "@material-ui/core/Box";
import Rating from "@material-ui/lab/Rating";
import Follow from "./Follow";
import InfiniteScroll from "react-infinite-scroller";
import Loader from "react-loader-spinner";
import ReadMoreReadLess from "./ReadMoreReadLess";
import {getCDNUrl} from "./CommonFunctions";
import UserReactionComponent from '../UserReaction/UserReactionComponent';
import FeedbackCard from './FeedbackCard';
import uuid from 'react-uuid';

class UserFeedback extends Component {

    constructor(props) {
        super(props);
        let validation = {
            title: {},
            description: {}
        }
        this.state = {
            userData: authService.getUserDetailsFromLocalStorage(),
            value: 0,
            validation,
            submitted: false,
            feedbackGiven: true,
            averageRating: 0,
            averageRatingForLastThirtyDays: 0,
            title: '',
            description: '',
            feedbacks: [],
            feedbacksCount: 0,
            pageSize: 5,
            pageNo: 0,
            pagination: false,
            active: 'iStar staractive',
            inActive: 'iStar',
            messages: null,
            disable: true,
            // editFeedBackId: '',
            // isEditFeedBack: false,
            // editFeedbackUserData: {}
        }

    }


    getOptimizedImage(personalInfo) {
        if (personalInfo.resizedProfileImages && personalInfo.resizedProfileImages['200x200'] != null) {
            return personalInfo.resizedProfileImages['200x200'];
        }
        return personalInfo.profileImage;
    }

    componentDidMount() {
        this.checkConfigFeedback();
        this.getAllFeedbacks(0, this.state.pageSize, false);
    }

    fetchMoreData() {
        let feedbacks = this.state.feedbacks;

        if (this.state.feedbacks) {
            this.setState({isResultLoading: true});
            let pageable = feedbacks.pageable;
            this.getAllFeedbacks(pageable.pageNumber + 1, this.state.pageSize, true);
        }
    }

    getAllFeedbacks(page, size, concatWithPrevious) {
        axios({
            method: 'get',
            url: process.env.REACT_APP_userServiceURL + '/feedback/getFeedbacksByActivityId/'
                + this.props.projectDetail.projectId + '?userId=' + this.state.userData.userId + "&page=" + page + "&size=" + size,
            headers: {'Content-Type': 'application/json'},
            withCredentials: true
        }).then(response => {
            if (response && response.data && response.data.body && response.status === 200) {
                let pagedData = response.data.body;
                if (concatWithPrevious === true && this.state.feedbacks && this.state.feedbacks.content) {
                    pagedData.content = this.state.feedbacks.content.concat(pagedData.content);
                }
                this.setState({
                    'feedbacks': pagedData,
                    'responseMessage': response.data.message,
                    'isResultLoading': false,
                    'pagination': response.data.body.last
                });
            }
        }).catch((err) => {
            console.log(err);
            this.setState({
                isResultLoading: false
            });
        });
    }


    checkConfigFeedback() {
        axios({
            method: 'get',
            url: process.env.REACT_APP_userServiceURL + '/backend/feedback/getFeedbacksConfigByActivityId/' + this.props.projectDetail.projectId + '?userId=' + this.state.userData.userId,
            headers: {'Content-Type': 'application/json'},
            withCredentials: true
        }).then((response) => {
            let res = response.data;
            if (res.message === 'Success!') {
                this.setState({'feedbackGiven': res.body.feedbackGiven});
                this.setState({'averageRating': res.body.averageRating});
                this.setState({'averageRatingForLastThirtyDays': res.body.averageRatingForLastThirtyDays});
            }
        }).catch((err) => {
            if (err && err.response && err.response.data) {
                this.setState({
                    isLoaded: true,
                    error: {message: err.response.data.message, err: err.response}
                });
            }
        });
    };

    handleTitleChange = (e) => {
        this.setState({'title': e.target.value});
        if (e.target.value.length > 0) {
            this.setState({disable: false});
        } else {
            this.setState({disable: true});
        }
    };

    handleDescriptionChange = (e) => {
        this.setState({'description': e.target.value});
        if (e.target.value.length > 0) {
            this.setState({disable: false});
        } else {
            this.setState({disable: true});
        }
    };
    setValue = (event, value) => {
        this.setState({'value': value});
        if (value > 0) {
            this.setState({disable: false});
        } else {
            this.setState({disable: true});
        }
    };

    redirectToProfile = (customUrl) => {
        window.location.href = "/profile/" + customUrl;
    }

    validateForm() {
        this.state.validation.description = {};
        let validationRequired = false;
        let errors = {};
        let formIsValid = true;
        if (_.isUndefined(this.state.description) ||
            _.isEmpty((this.state.description || "").toString()) ||
            _.isNull(this.state.description)) {
            this.setState({
                error: {message: 'Please provide a valid description'}
            });
            formIsValid = false;
            validationRequired = true;
        }
        if (_.isUndefined(this.state.title) ||
            _.isEmpty((this.state.title || "").toString()) ||
            _.isNull(this.state.title)) {
            this.setState({
                error: {message: 'Please enter a valid title'}
            });
            formIsValid = false;
            validationRequired = true;
        }
        if (_.isUndefined(this.state.value) ||
            _.isEmpty((this.state.value || "").toString())) {
            this.setState({
                error: {message: 'Please enter a valid feedback'}
            });
            formIsValid = false;
            validationRequired = true;
        }
        this.setState({
            errors: errors
        });
        setTimeout(() => {
            this.setState({
                error: {},
            });
        }, 5000);
        return formIsValid;

    }

    /* upadting  feedback list array here */
    getUpdatedFeedbackList = () => {
        let feedbacksList = this.state.feedbacks.content
        let index = feedbacksList && feedbacksList.findIndex(item => item.id === this.state.editFeedBackId);
        if(index > -1){
            feedbacksList[index] = { ...feedbacksList[index], title: this.state.title, description: this.state.description, rating: this.state.value};
        }
        this.setState({
            feedbacks: { ...this.state.feedbacks, content: feedbacksList},
        });
    }

    handleSubmit = (event) => {
        event.preventDefault();
        this.setState({isLoading: true})
        if (this.validateForm()) {
            this.setState({'submitted': true});
            let body = {
                "userId": this.state.userData.userId,
                "entityId": this.props.projectDetail.projectId,
                "title": this.state.title,
                "description": this.state.description,
                "rating": this.state.value,
                // ...(this.state.editFeedBackId && { feedbackId: this.state.editFeedBackId })
            };


            axios({
                method: 'post',
                url: process.env.REACT_APP_userServiceURL + '/backend/feedback/create/',
                // url: `${process.env.REACT_APP_userServiceURL}/backend/feedback/${this.state.editFeedBackId ? "edit" : "create"}/`,
                headers: {'Content-Type': 'application/json'},
                data: body,
                withCredentials: true
            }).then((response) => {
                let res = response.data;
                    if (res.message === 'Success!') {

                        // if(this.state.editFeedBackId){
                        // this.getUpdatedFeedbackList();
                        // window.$("#feedbackViewpop").modal('hide')
                        // this.setState({isEditFeedBack: false, editFeedbackUserData: {}, editFeedBackId: "", title: '', description: "", value: ''})  
                        // }else{

                            this.getAllFeedbacks(0, this.state.pageSize, false);
                            this.checkConfigFeedback();
                            this.setState({'title': '', 'description': ''});
                            this.state.isSubmitted = true;
                            this.setState({isLoading: false});
                            this.setState({disable: true})
                        // }  
                    }
            }).catch((err) => {
                if (err && err.response && err.response.data) {
                    this.setState({
                        isLoaded: true,
                        isSubmitted: false,
                        error: {message: err.response.data.message, err: err.response}
                    });
                }
            });
            setTimeout(() => {
                this.setState({
                    error: {},
                    isLoading: false
                });
            }, 5000);
        }
    };

    handleFeedbackEdit = (data) => {
        this.setState({
           isEditFeedBack: true,
           editFeedBackId: data?.id,
           title: data?.title,
           description: data?.description,
           value: data?.rating,
           editFeedbackUserData : data
        },() => {
            window.$("#feedbackViewpop").modal('show');
        })
    };

    handleCloseFeedbackEditPopUp = () => {
        this.setState({
            isEditFeedBack: false,
            editFeedBackId:"",
            title: "",
            description: "",
            value: "",
            editFeedbackUserData : {}
        })
    }

    handleFeedbackFlag = (data) => {
        let postData = {
            userId: this.state.userData?.userId,
            feedbackId: data?.id,
            flag: !data?.flagged
        };

        /* feedback update api call */ 
        axios({
            method: 'post',
            url: process.env.REACT_APP_userServiceURL + '/backend/feedback/flag/update/',
            headers: {'Content-Type': 'application/json'},
            data: postData,
            withCredentials: true
        }).then((response) => {
            let res = response.data;
            if (res.status === '201 CREATED') {
                let feedbacksList = this.state.feedbacks.content
                let index = feedbacksList && feedbacksList.findIndex(item => item.id === data?.id);
                if(index > -1){
                    feedbacksList[index] = { ...feedbacksList[index], flagged: !data.flagged};
                }
                this.setState({
                    feedbacks: { ...this.state.feedbacks, content: feedbacksList},
                });
            }
        }).catch((err) => {
            if (err && err.response && err.response.data) {
                this.setState({
                    error: {message: err.response.data.message, err: err.response}
                });
            }
        });
    };


    render() {
        const {error, feedbackGiven} = this.state;
        return <>
            <div className="pdftopratingview">
                <div>
                    <span>Overall Rating:</span>
                    <div className="gbrating">
                        <i className={this.state.averageRating > 0 ? this.state.active : this.state.inActive}/>
                        <i className={this.state.averageRating > 1 ? this.state.active : this.state.inActive}/>
                        <i className={this.state.averageRating > 2 ? this.state.active : this.state.inActive}/>
                        <i className={this.state.averageRating > 3 ? this.state.active : this.state.inActive}/>
                        <i className={this.state.averageRating > 4 ? this.state.active : this.state.inActive}/>
                    </div>
                    <div className="ratingresult">{/*{this.state.averageRating} rating average*/} Average Rating</div>
                </div>
                <div className="last30">
                    <span>Rating In Previous 30 Days</span>
                    <div className="gbrating">
                        <i className={this.state.averageRatingForLastThirtyDays > 0 ? this.state.active : this.state.inActive}/>
                        <i className={this.state.averageRatingForLastThirtyDays > 1 ? this.state.active : this.state.inActive}/>
                        <i className={this.state.averageRatingForLastThirtyDays > 2 ? this.state.active : this.state.inActive}/>
                        <i className={this.state.averageRatingForLastThirtyDays > 3 ? this.state.active : this.state.inActive}/>
                        <i className={this.state.averageRatingForLastThirtyDays > 4 ? this.state.active : this.state.inActive}/>
                    </div>
                    <div className="ratingresult">{/*this.state.averageRatingForLastThirtyDays*/} Average Rating
                    </div>
                </div>
            </div>
            {!feedbackGiven ?
                <div className="addfeedbackform">
                    <figure className="user"><img
                        src={this.state.userData.profileImage != null ? getCDNUrl(this.getOptimizedImage(this.state.userData)) : (this.state.userData.type != "COMPANY" ? "https://cdn.dscovr.com/images/users1.png" : "https://cdn.dscovr.com/images/DefaultBusiness.png")}
                        alt=""/></figure>
                    <div className="addfeedbformbox">
                        <form onSubmit={this.handleSubmit}>
                            <h4>Add your Feedback</h4>
                            <div>
                                <Box component="fieldset" mb={4} borderColor="transparent">
                                    <Rating
                                        name="simple-controlled-add"
                                        value={this.state.value}
                                        onChange={(event, newValue) => {
                                            this.setValue(event, newValue);
                                        }}
                                    />
                                </Box>

                            </div>
                            <div className="form-group">
                                <input type="text" className="form-control dginput" onChange={this.handleTitleChange}
                                       placeholder="Add title..."/>
                            </div>
                            <div className="form-group">
                                <textarea name="" id="" onChange={this.handleDescriptionChange}
                                          className="form-control dginput"
                                          placeholder="Write feedback here..."/>
                            </div>
                            <div className="bottbtnwrap">
                                {this.state.error && this.state.error.message !== "" && this.state.error.message !== undefined &&
                                <div className="login-feedback-error">
                                    {this.state.error.message}
                                </div>
                                }
                                {this.state.success &&
                                <div className="login-feedback-error">
                                    {this.state.messages}
                                </div>}
                                <input type="submit" disabled={this.state.disable} value="Submit" className="btn btnsubmit"/>
                            </div>
                        </form>
                    </div>
                </div> : null
            }


            <div className="usernotifwrap"
                 data-mcs-theme="minimal-dark">
                <div id="scrollableDiv">
                    {
                        this.state.feedbacks && this.state.feedbacks.content && this.state.feedbacks.content.length > 0
                        && <InfiniteScroll
                            loadMore={this.fetchMoreData.bind(this)}
                            hasMore={!this.state.isResultLoading && !this.state.pagination}
                            loader={<Loader
                                type="ThreeDots"
                                color="#00394D"
                                height={50}
                                width={60}
                                timeout={6000}
                            />}
                        >
                            <div className="feedbreviewlist">
                                {this.state.feedbacks && this.state.feedbacks.content && this.state.feedbacks.content.length > 0 && this.state.feedbacks.content.map((data, index) => {
                                    
                                    return (
                                        // <div className="feedbreviewrow" key={index}>
                                        //             <div className={"forumcommtvlisttop" + (data.userType === "COMPANY" ? " orgnz" : "")}>
                                        //                 <div className="fuserblk">
                                        //                     <figure onClick={(e) => {
                                        //                         e.preventDefault();
                                        //                         this.redirectToProfile(data.customUrl)
                                        //                     }}><a href=""><img
                                        //                         src={!_.isNull(data.profileImage) && !_.isUndefined(data.profileImage) ? getCDNUrl(data.profileImage) : (data.userType != "COMPANY" ? "https://cdn.dscovr.com/images/users1.png" : "https://cdn.dscovr.com/images/DefaultBusiness.png")}
                                        //                         alt=""/></a></figure>
                                        //                     <div style={{flex: "1"}}>
                                        //                         <div onClick={(e) => {
                                        //                             e.preventDefault();
                                        //                             this.redirectToProfile(data.customUrl)
                                        //                         }}
                                        //                             style={{display: "inline-block", cursor:"pointer"}}>
                                        //                             {data.userName}
                                        //                         </div>
                                        //                         {!data.deactivated  &&
                                        //                             <Follow followed={data.followed}
                                        //                                 userId={data.userId}/>}
                                        //                         {/*<span>3:40 PM 20th Nov 2019</span>*/}
                                        //                         <span>{new Intl.DateTimeFormat("en", {
                                        //                             hour: "numeric",
                                        //                             minute: "numeric",
                                        //                             year: "numeric",
                                        //                             month: "short",
                                        //                             day: "2-digit"
                                        //                         }).format(data.time)}</span>
                                        //                     </div>
                                        //                 </div>
                                        //                 <div className="fdate">
                                        //                     <UserReactionComponent item={data} key={data.id} />
                                        //                 </div>
                                        //                 <div className="contxmenu" style={{marginLeft:"10px"}}>
                                        //                     <button type="button" className="btn" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i className="iKebab"/></button>
                                        //                     <div className="dropdown-menu fadeIn animated">
                                        //                         {data.canEdit && <a className="dropdown-item"  onClick={e => {this.handleFeedbackEdit(data)}}><i className="iEditBox" style={{fontSize: '13px'}}/>Edit</a>}
                                        //                         {data.canFlag && <a className="dropdown-item" href="javascript:void(0)" onClick={() => {this.handleFeedbackFlag(data)}} ><i className={!data.flagged ? "iPin" : "ipin-icon_RM"} style={{ fontSize: '14px' }} /> {!data.flagged ? "Flag" : "Unflag"} </a>}
                                        //                     </div>
                                        //                 </div>

                                        //             </div>
                                        //             <div className="forumcommtvlistdesc">
                                        //                 <div className="gbrating">
                                        //                     <Box component="fieldset" mb={4}
                                        //                         borderColor="transparent">
                                        //                         <Rating
                                        //                             name="simple-controlled"
                                        //                             value={data.rating}
                                        //                             readOnly={true}
                                        //                         />
                                        //                     </Box>
                                        //                 </div>
                                        //                 <h4>{data.title}</h4>
                                        //                 <ReadMoreReadLess
                                        //                     key={data.id}
                                        //                     id={data.id}
                                        //                     description={data.description}/>
                                        //             </div>
                                        // </div>\

                                        <FeedbackCard data={data} key={uuid()} />
                                    )
                                })}
                            </div>
                        </InfiniteScroll>
                    }
                </div>
                {/* feedback edit & Flag implementation */}
                {/* {this.state.isEditFeedBack &&
                     <div id="feedbackViewpop" className="modal fade dgpopup reqendorse">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-body">
                                    <div className="profsectionwrap endorsements">
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => {this.handleCloseFeedbackEditPopUp()}}>
                                            <span aria-hidden="true">&times;</span></button>
                                        <div className="profsectiondesc">
                                        <div>
                                            <figure className="user">
                                                <img  src={this.state.editFeedbackUserData?.profileImage != null ? getCDNUrl(this.getOptimizedImage(this.state.editFeedbackUserData)) : (this.state.editFeedbackUserData?.userType != "COMPANY" ? "https://cdn.dscovr.com/images/users1.png" : "https://cdn.dscovr.com/images/DefaultBusiness.png")} alt=""/>
                                            </figure>

                                            <div onClick={(e) => { e.preventDefault(); this.redirectToProfile(this.state.editFeedbackUserData?.customUrl)}} style={{display: "inline-block", cursor:"pointer"}}>
                                                {this.state.editFeedbackUserData?.userName}
                                            </div>
                                            {!this.state.editFeedbackUserData?.deactivated  && <Follow followed={this.state.editFeedbackUserData?.followed} userId={this.state.editFeedbackUserData?.userId}/>}
                                        </div>
                                            <div className="addfeedbackform">
                                                <div className="addfeedbformbox">
                                                    <form onSubmit={this.handleSubmit}>
                                                        <h4>Edit your Feedback</h4>
                                                        <div>
                                                            <Box component="fieldset" mb={4} borderColor="transparent">
                                                                <Rating
                                                                    name="simple-controlled"
                                                                    value={this.state.value}
                                                                    onChange={(event, newValue) => {this.setValue(event, newValue)}}
                                                                />
                                                            </Box>
                                                        </div>
                                                        <div className="form-group">
                                                            <input type="text" className="form-control dginput" value={this.state.title} onChange={this.handleTitleChange}
                                                                placeholder="Add title..."/>
                                                        </div>
                                                        <div className="form-group">
                                                            <textarea name="" id="" onChange={this.handleDescriptionChange} value={this.state.description} 
                                                                    className="form-control dginput"
                                                                    placeholder="Write feedback here..."/>
                                                        </div>
                                                        <div className="bottbtnwrap">
                                                            {this.state.error && this.state.error.message !== "" && this.state.error.message !== undefined &&
                                                            <div className="login-feedback-error">
                                                                {this.state.error.message}
                                                            </div>
                                                            }
                                                            {this.state.success &&
                                                            <div className="login-feedback-error">
                                                                {this.state.messages}
                                                            </div>}
                                                            <input type="submit" disabled={this.state.disable} value={"Update"} className="btn btnsubmit"/>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div> 
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                } */}
            </div>
        </>
    }
}

export default UserFeedback;


